<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <v-card flat>
      <v-toolbar style="color: white" color="secondary">
        <h3>{{message}}</h3>
        <v-spacer></v-spacer>
        <v-toolbar-items class="mt-6">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-tabs left fixed-tabs v-model="tab" color="secondary" v-if="history.release != null && history.release.length > 0">
          <v-tooltip bottom max-width="386" open-delay="600">
            <template v-slot:activator="{ on, attrs }">
              <v-tab id="tab" key="m1" @click="loadMain()" v-bind="attrs" v-on="on">
                Prozesshistorie
              </v-tab>
            </template>
            <span>Bei dem „Stimmungsbild der Beschäftigten“ können Sie sehen, wie hoch die Arbeitszufriedenheit, Arbeitseffizienz und Betriebsbindung der Beschäftigten ist. Die Werte ergeben sich aus der Beschäftigtenumfrage und werden nach dem Schulnotensystem ausgewertet. 1 bedeutet daher „sehr gut“ und 6 „ungenügend“</span>
          </v-tooltip>
        <v-tooltip bottom max-width="600" open-delay="600">
          <template v-slot:activator="{ on, attrs }">
            <v-tab id="tab" key="m1" @click="loadPublish()" v-bind="attrs" v-on="on">
              Freigabeanfragen
            </v-tab>
          </template>
          <span>Hier sehen Sie, ob die Beschäftigten in den Kategorien Arbeitsaufgabe, Arbeitsbedingung, Arbeitsrolle, Personensystem und soziales Umfeld Stressoren oder Ressourcen wahrnehmen. Diese 5 Bereiche haben jeweils Unterbereiche. Detaillierte Informationen darüber erhalten Sie, indem Sie die Kategorien anklicken. Stressoren sind andauernde physische oder psychische Aufwände und erfordern daher bestimmte Fähigkeiten von berufstätigen Personen, sodass sie Kosten darstellen. Im Gegensatz dazu ermöglichen Ressourcen, Arbeitsziele zu erreichen, arbeitsbedingten Belastungen und damit einhergehenden physischen und psychischen Kosten entgegenzuwirken sowie persönliches Wachstum, Lernen und Entwicklung anzustoßen. Es wird abgestrebt, dass die Ressourcen die Stressoren überwiegen. Die Werte ergeben sich aus der Beschäftigtenumfrage und werden nach dem Schulnotensystem ausgewertet. 1 bedeutet daher „sehr gut“ und 6 „ungenügend.</span>
        </v-tooltip>
      </v-tabs>
      <div class="columns" id="columns">
      <v-card flat class="column is-one-quarter border-right">
        <v-subheader v-if="rightPanelHeading != null">{{rightPanelHeading}}</v-subheader>
        <v-list>
        <template v-for="(item, index) in history">

        <v-list-item
          @click="itemSelected(item)"
          :key="index"
        >
          <v-list-item-content class="list-item">
            <v-list-item-title class="text-wrap">
              <span class="font-m">{{ item.committer }}</span>
              <span class="date float-right mt-1">{{item.timestamp | moment("DD.MM.YYYY HH:mm")}}</span>
<!--               <v-chip v-if="tabVal == 'RELEASE'" outlined color="warning">In Prüfung</v-chip> -->
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="item.commitHash" class="ma-0 pa-0" />
        </template>
        </v-list>
      </v-card>
    <div class="column">
      <div id="viewerFrame" v-if="selectedItem != null">
        <BpmnViewer v-if="dialog" ref="bpmnViewer" :diagramXML="selectedItem.processXML"/>  
      </div>
      <div v-else>
        <p v-if="history.length == 0" class="text-gray mt-10"
           style="text-align-last: center; margin: 10px; font-size:0.8rem;">Es ist noch keine Änderungshistorie verfügbar</p>
        <p v-else class="text-gray mt-10" style="text-align-last: center; margin: 10px; font-size:0.8rem;">Prozess
          auswählen um
          Vorschau
          anzuzeigen</p>
      </div>
    </div>
  </div>
      <!-- <div v-if="loaded">
        <BpmnViewer v-if="dialog" ref="bpmnViewer" :diagramXML="selectedProcessXml" style="margin-top: 64px" />  
      </div>
      <div v-else>
        <p v-if="availableProcesses.length == 0" style="text-align-last: center; margin: 10px; font-size:1.25rem;">Es sind leider keine Prozesse zum verknüpfen vorhanden. Fügen Sie neue Prozesse zur Plattform hinzu um diese verknüpfen zu können.</p>
        <p v-else style="text-align-last: center; margin: 10px; font-size:1.25rem;">Prozess auswählen um Vorschau anzuzeigen</p>    
      </div> -->
      <div v-if="canEdit" id="footer" class="bg-gray pr-6">
          <v-btn elevation="0" style="float:right;" color="primary" @click="chooseItem">
            {{btnText}}
          </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import BpmnViewer from "@/pages/ProcessModeling/BpmnViewer";
export default {
  name: "PreviewProcessModelDialog",
  components:{
    BpmnViewer
  },
  props:{
    canEdit: Boolean
  },
  data() {
    return {
      dialog: true,
      resolve: null,
      reject: null,
      selectedItem: null,
      rightPanelHeading: "",
      message: "",
      btnText: "",
      history: [],
    }
  },
  methods: {
    itemSelected(item){
      this.selectedItem = item;
    },
    open(items, message, btnText,  rightPanelHeading) {
      this.selectedProcess = null;
      this.history = items;
      this.message = message;
      this.btnText = btnText;
      this.rightPanelHeading = rightPanelHeading;
      this.selectedProcess = items[0];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    closeDialog(){
      if(this.reject != null) this.reject();
      this.$emit('close');
      this.dialog = false;
    },
    chooseItem(item){
      this.resolve(this.selectedItem);
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
#viewerFrame{
  position: absolute;
  right: 0;
  left: 25% !important;
  bottom: 0;
  top:0;

}
#columns{
  margin:0;
  position:absolute;
  height: calc(100% - (2*64px));
  width:100%;
}
.dialog {
  flex-grow: 0;
  padding: 20px;
  background-color: #fff;
}
.description{
  display:inline-block;
  width: calc(60% - 5px);
  height: 400px;
  margin: 15px 5px 0 0;
}
.modelList{
  display:inline-block;
  width: calc(40% - 15px);
  height: 400px;
  margin: 5px 0 0 15px;
  border-left: 2px solid var(--v-primary-base);
}
.elementDivider{

  margin: 1px;
  border: 0.5px solid var(--v-primary-base);
}
#footer{
  position: absolute;
  width:100%;
  bottom: 0;
  padding:10px;
  height:64px;
}

</style>